import { Box } from "@mui/material";
import CheckIcon from "@mui/icons-material/Check";
import CloseIcon from "@mui/icons-material/Close";
import { style } from "./YesNoTag.style";
import { SxWithMandatoryWidth } from "../GenericTableRowTooltip";

const YesNoTag = ({ yes, sx }: { yes: boolean, sx?: SxWithMandatoryWidth }) => {
	const label = yes ? (
		<>
			<CheckIcon
				fontSize="small"
				data-testid="yesNoTag"
				sx={{ ...style.icon, ...style.iconYes, ...sx }}
			/>{" "}
			Yes
		</>
	) : (
		<>
			<CloseIcon
				fontSize="small"
				data-testid="yesNoTag"
				sx={{ ...style.icon, ...style.iconNo }}
			/>{" "}
			No
		</>
	);

	return <Box sx={{ ...style.root, ...(!yes ? style.no : {}) }}>{label}</Box>;
};

export default YesNoTag;
